import { memo } from 'react'
import { Link, useLocation } from 'react-router'

import { Button } from '@/components/ui/button'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import { cn } from '@/lib/utils'

import {
  SidebarSubMenuItem as SidebarSubMenuItemType,
  SidebarThemes,
} from '../types'

interface SidebarSubMenuItemProps {
  subItem: SidebarSubMenuItemType
  variant?: 'expandable' | 'dropdown'
  theme?: SidebarThemes
}

export const SidebarSubMenuItem = memo<SidebarSubMenuItemProps>(
  ({ subItem, variant = 'expandable', theme = 'light' }) => {
    const { pathname } = useLocation()

    const isActive = subItem.path.includes(pathname)

    if (variant === 'dropdown') {
      return (
        <DropdownMenuItem
          className={cn(
            'cursor-pointer hover:bg-accent hover:text-accent-foreground',
            isActive && 'bg-accent font-medium text-accent-foreground',
            subItem.hidden && 'hidden',
          )}
          disabled={subItem.disabled}
          asChild
        >
          <Link to={subItem.path} className="flex w-full items-center">
            <span>{subItem.title}</span>
          </Link>
        </DropdownMenuItem>
      )
    }

    return (
      <Button
        variant="ghost"
        size="sm"
        className={cn(
          'group flex w-full justify-between rounded-2xl',
          theme === 'dark'
            ? 'text-[#A4A3DA] hover:bg-sidebar-primary-hover hover:text-white'
            : 'text-gray-700 hover:bg-accent hover:text-accent-foreground',
          isActive &&
            theme === 'dark' &&
            'bg-sidebar-primary-hover font-medium text-white',
          isActive &&
            theme === 'light' &&
            'bg-accent font-medium text-accent-foreground',
          subItem.hidden && 'hidden',
        )}
        disabled={subItem.disabled}
        asChild
      >
        <Link
          to={subItem.path}
          className="flex w-full items-center justify-between"
        >
          <span>{subItem.title}</span>
          {subItem.actionsPopover}
        </Link>
      </Button>
    )
  },
)

SidebarSubMenuItem.displayName = 'SidebarSubMenuItem'
